import { useTranslation } from 'react-i18next';
import { useFilePreview } from '~/utils/hooks/useFilePreview';
import { FormValues } from '~/utils/interface/setup';

export const str = (value: FormValues[string]) =>
  typeof value === 'string' || typeof value === 'number' ? String(value) : '';

export const fullName = (form: FormValues) => [str(form.firstName), str(form.lastName)].filter(Boolean).join(' ');

export const joinParts = (parts: FormValues[string][], separator = ', ') =>
  parts.map(str).filter(Boolean).join(separator);

export const YesNo = ({ value }: { value: FormValues[string] }) => {
  const { t } = useTranslation();
  return <>{t(value === true ? 'pages.setup.table.yes' : 'pages.setup.table.no')}</>;
};

// `src` is the saved url, or a File the user just picked (not synced yet), previewed locally.
export const Avatar = ({ src, name }: { src?: FormValues[string]; name: string }) => {
  const url = useFilePreview(src);

  return (
    <span className='flex items-center gap-2'>
      <span className='h-8 w-8 shrink-0 overflow-hidden rounded-full bg-muted'>
        {url && <img src={url} alt='' className='h-full w-full object-cover' />}
      </span>
      <span className='font-medium text-foreground'>{name}</span>
    </span>
  );
};

export const RepeatLabel = ({ value }: { value: FormValues[string] }) => {
  const { t } = useTranslation();
  return <>{value ? t(`pages.setup.repeat.${str(value)}`) : ''}</>;
};
